// import React, { useEffect, useRef, useState } from 'react';

// const PdfViewer = ({ documentUrl, onBack }) => {
//   const canvasRef = useRef(null);
//   const videoRef = useRef(null);
//   const [fileType, setFileType] = useState('');

//   useEffect(() => {
//     console.log("Document URL:", documentUrl);
//     // Determine the file type based on the file extension
//     if (documentUrl.endsWith('.pdf')) {
//       setFileType('pdf');
//     } else if (documentUrl.endsWith('.epub')) {
//       setFileType('epub');
//     } else if (documentUrl.endsWith('.html') || documentUrl.endsWith('.htm')) {
//       setFileType('html');
//     } else if (
//       documentUrl.endsWith('.jpg') ||
//       documentUrl.endsWith('.jpeg') ||
//       documentUrl.endsWith('.png') ||
//       documentUrl.endsWith('.gif') ||
//       documentUrl.endsWith('.bmp') ||
//       documentUrl.endsWith('.webp')
//     ) {
//       setFileType('image');
//     } else {
//       setFileType('unsupported');
//     }
//   }, [documentUrl]);

//   const handleKeyDown = (e) => {
//     switch (e.keyCode) {
//       case 8: // Back key
//       case 461:
//       case 10009:
//         handleBack();
//         break;
//       default:
//         break;
//     }
//   };

//   const handleBack = () => {
//     if (videoRef.current) {
//       videoRef.current.src = "";
//     }
//     if (onBack) {
//       onBack(); // Call the onBack function if it exists
//     }
//   };

//   useEffect(() => {
//     // Attach the keydown event listener to the window
//     window.addEventListener('keydown', handleKeyDown);

//     return () => {
//       // Clean up the event listener on unmount
//       window.removeEventListener('keydown', handleKeyDown);
//     };
//   }, []); // Empty dependency array to ensure it only runs on mount and unmount

//   useEffect(() => {
//     const renderPDF = async () => {
//       if (!window.pdfjsLib) {
//         // console.error("PDF.js is not loaded. Make sure it's included in your HTML file.");
//         return;
//       }

//       try {
//         const pdf = await window.pdfjsLib.getDocument(documentUrl).promise;
//         const page = await pdf.getPage(1);

//         const scale = 1.5;
//         const viewport = page.getViewport({ scale });

//         const canvas = canvasRef.current;
//         const context = canvas.getContext('2d');
//         canvas.height = viewport.height;
//         canvas.width = viewport.width;

//         const renderContext = {
//           canvasContext: context,
//           viewport: viewport,
//         };
//         await page.render(renderContext);
//       } catch (error) {
//         console.error("Error rendering PDF:", error);
//       }
//     };

//     if (fileType === 'pdf') {
//       renderPDF();
//     }
//   }, [documentUrl, fileType]);

//   return (
//     <div
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         backgroundColor: '#000',
//         color: '#fff',
//       }}
//     >
//       {fileType === 'pdf' ? (
//         <canvas ref={canvasRef} />
//       ) : fileType === 'epub' ? (
//         <div style={{ textAlign: 'center' }}>
//           <p>This viewer currently does not support .epub files.</p>
//           <p>Please use an external app to view this format.</p>
//         </div>
//       ) : fileType === 'html' ? (
//         <iframe
//           src={documentUrl}
//           style={{
//             width: '100%',
//             height: '100%',
//             border: 'none',
//           }}
//           title="HTML Document Viewer"
//         />
//       ) : fileType === 'image' ? (
//         <img
//           src={documentUrl}
//           alt="Document"
//           style={{
//             maxWidth: '100%',
//             maxHeight: '100%',
//             objectFit: 'contain',
//           }}
//         />
//       ) : (
//         <div style={{ textAlign: 'center' }}>
//           <p>Unsupported file format.</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PdfViewer;


import React, { useEffect, useState } from 'react';
import { sendTestMatomoEvent } from '../Analytics/MatomoManager/matomoTest';
import { AppContext } from '../AppContext';
import { useContext } from 'react';

const PdfViewer = ({ itemDetails,documentUrl, onBack }) => {
  const [fileType, setFileType] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
      const { sourceContext, setSourceContext } = useContext(AppContext);


  console.log("Document URL:", documentUrl);

  // Determine file type from URL
  useEffect(() => {
    if (!documentUrl) return;
    
    try {
      const url = new URL(documentUrl);
      const pathname = url.pathname.toLowerCase();
      const extension = pathname.split('.').pop();
      
      if (extension === 'pdf') {
        setFileType('pdf');
      } else if (extension === 'epub') {
        setFileType('epub');
      } else if (['html', 'htm'].includes(extension)) {
        setFileType('html');
      } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
        setFileType('image');
         sendTestMatomoEvent({
        eventCategory:"Image",
        eventAction:"ViewNow",
        eventName:`${itemDetails[0].id}/${itemDetails[0].title}`,
      })

      sendTestMatomoEvent({
        eventCategory:"Image",
        eventAction:"Open",
        eventName:`${itemDetails[0].id}/${itemDetails[0].title}`,
        sourceContext: sourceContext || "",
      })
      } else {
        setFileType('unsupported');
      }
    } catch (e) {
      setFileType('unsupported');
      console.error('Invalid URL:', e);
    }
  }, [documentUrl]);

  // Handle back button/key for TV
  useEffect(() => {
    
    const handleKeyDown = (e) => {
      if ([8, 461, 10009].includes(e.keyCode)) { // Back button codes for various TV platforms
        onBack?.();
      }
       else if (e.keyCode === 38) {
        e.preventDefault();
        const scrollAmount = window.innerHeight * 0.8; // Scroll 80% of viewport height
        window.scrollBy({
          top: -scrollAmount,
          behavior: 'smooth'
        });
      } 
      // Down arrow - scroll down
      else if (e.keyCode === 40) {
        e.preventDefault();
        const scrollAmount = window.innerHeight * 0.8; // Scroll 80% of viewport height
        window.scrollBy({
          top: scrollAmount,
          behavior: 'smooth'
        });
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onBack]);

  const getViewerUrl = (url) => {
    try {
      // Use Google Docs viewer for PDFs
      if (fileType === 'pdf') {
        return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
      }
      return url;
    } catch (e) {
      return url;
    }
  };

  if (loading) {
    return (
      <div style={{ 
        color: 'white', 
        textAlign: 'center', 
        padding: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <p>Loading document...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        color: 'white', 
        textAlign: 'center', 
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <h3>Error Loading Document</h3>
        <p>{error}</p>
        <button 
          onClick={onBack}
          style={{
            padding: '10px 20px',
            marginTop: '20px',
            fontSize: '16px',
            backgroundColor: '#333',
            color: 'white',
            border: 'none',
            borderRadius: '4px'
          }}
        >
          Back
        </button>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      backgroundColor: '#000',
      overflow: 'hidden'
    }}>
      {fileType === 'pdf' || fileType === 'html' ? (
        <iframe
          src={getViewerUrl(documentUrl)}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block'
          }}
          title="Document Viewer"
          onLoadStart={() => setLoading(true)}
          onLoad={() => setLoading(false)}
          onError={() => {
            setError('Failed to load document. Opening in browser...');
            setTimeout(() => {
              window.location.href = documentUrl;
            }, 2000);
          }}
        />
      ) : fileType === 'epub' ? (
        <div style={{ 
          color: 'white', 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}>
          <p>EPUB format not supported</p>
          <button 
            onClick={onBack}
            style={{
              padding: '10px 20px',
              marginTop: '20px',
              fontSize: '16px',
              backgroundColor: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            Back
          </button>
        </div>
      ) : fileType === 'image' ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          backgroundColor: '#000'
        }}>
          <img
            src={documentUrl}
            alt="Document"
            style={{ 
              maxWidth: '100%', 
              maxHeight: '100%', 
              objectFit: 'contain' 
            }}
            onLoad={() => setLoading(false)}
            onError={() => setError('Failed to load image')}
          />
        </div>
      ) : (
        <div style={{ 
          color: 'white', 
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%'
        }}>
          <p>Unsupported file format</p>
          <button 
            onClick={onBack}
            style={{
              padding: '10px 20px',
              marginTop: '20px',
              fontSize: '16px',
              backgroundColor: '#333',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            Back
          </button>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;


// import React, { useEffect, useState, useRef } from 'react';

// const PdfViewer = ({ documentUrl, onBack }) => {
//   const [fileType, setFileType] = useState('');
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const iframeRef = useRef(null);

//   console.log("Document URL:", documentUrl);

//   // Determine file type from URL
//   useEffect(() => {
//     if (!documentUrl) return;
    
//     try {
//       const url = new URL(documentUrl);
//       const pathname = url.pathname.toLowerCase();
//       const extension = pathname.split('.').pop();
      
//       if (extension === 'pdf') {
//         setFileType('pdf');
//       } else if (extension === 'epub') {
//         setFileType('epub');
//       } else if (['html', 'htm'].includes(extension)) {
//         setFileType('html');
//       } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
//         setFileType('image');
//       } else {
//         setFileType('unsupported');
//       }
//     } catch (e) {
//       setFileType('unsupported');
//       console.error('Invalid URL:', e);
//     }
//   }, [documentUrl]);

//   // Handle back button/key for TV and scroll navigation
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if ([8, 461, 10009].includes(e.keyCode)) { // Back button codes
//         onBack?.();
//       } else if (fileType === 'pdf' && iframeRef.current) {
//         // For PDFs, we need to handle scrolling within the iframe
//         const iframeWindow = iframeRef.current.contentWindow;
//         if (!iframeWindow) return;

//         const scrollAmount = window.innerHeight * 0.8;
        
//         if (e.keyCode === 38) { // Up arrow
//           e.preventDefault();
//           iframeWindow.scrollBy({
//             top: -scrollAmount,
//             behavior: 'smooth'
//           });
//         } else if (e.keyCode === 40) { // Down arrow
//           e.preventDefault();
//           iframeWindow.scrollBy({
//             top: scrollAmount,
//             behavior: 'smooth'
//           });
//         }
//       } else {
//         // For other content types, scroll the main window
//         const scrollAmount = window.innerHeight * 0.8;
        
//         if (e.keyCode === 38) { // Up arrow
//           e.preventDefault();
//           window.scrollBy({
//             top: -scrollAmount,
//             behavior: 'smooth'
//           });
//         } else if (e.keyCode === 40) { // Down arrow
//           e.preventDefault();
//           window.scrollBy({
//             top: scrollAmount,
//             behavior: 'smooth'
//           });
//         }
//       }
//     };
    
//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [onBack, fileType]);

//   const getViewerUrl = (url) => {
//     try {
//       // Use Google Docs viewer for PDFs
//       if (fileType === 'pdf') {
//         return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
//       }
//       return url;
//     } catch (e) {
//       return url;
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ 
//         color: 'white', 
//         textAlign: 'center', 
//         padding: 20,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh'
//       }}>
//         <p>Loading document...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ 
//         color: 'white', 
//         textAlign: 'center', 
//         padding: 20,
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh'
//       }}>
//         <h3>Error Loading Document</h3>
//         <p>{error}</p>
//         <button 
//           onClick={onBack}
//           style={{
//             padding: '10px 20px',
//             marginTop: '20px',
//             fontSize: '16px',
//             backgroundColor: '#333',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px'
//           }}
//         >
//           Back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       width: '100%',
//       height: '100vh',
//       backgroundColor: '#000',
//       overflow: 'hidden'
//     }}>
//       {fileType === 'pdf' || fileType === 'html' ? (
//         <iframe
//           ref={iframeRef}
//           src={getViewerUrl(documentUrl)}
//           style={{
//             width: '100%',
//             height: '100%',
//             border: 'none',
//             display: 'block'
//           }}
//           title="Document Viewer"
//           onLoadStart={() => setLoading(true)}
//           onLoad={() => setLoading(false)}
//           onError={() => {
//             setError('Failed to load document. Opening in browser...');
//             setTimeout(() => {
//               window.location.href = documentUrl;
//             }, 2000);
//           }}
//         />
//       ) : fileType === 'epub' ? (
//         <div style={{ 
//           color: 'white', 
//           textAlign: 'center',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100%'
//         }}>
//           <p>EPUB format not supported</p>
//           <button 
//             onClick={onBack}
//             style={{
//               padding: '10px 20px',
//               marginTop: '20px',
//               fontSize: '16px',
//               backgroundColor: '#333',
//               color: 'white',
//               border: 'none',
//               borderRadius: '4px'
//             }}
//           >
//             Back
//           </button>
//         </div>
//       ) : fileType === 'image' ? (
//         <div style={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100%',
//           backgroundColor: '#000'
//         }}>
//           <img
//             src={documentUrl}
//             alt="Document"
//             style={{ 
//               maxWidth: '100%', 
//               maxHeight: '100%', 
//               objectFit: 'contain' 
//             }}
//             onLoad={() => setLoading(false)}
//             onError={() => setError('Failed to load image')}
//           />
//         </div>
//       ) : (
//         <div style={{ 
//           color: 'white', 
//           textAlign: 'center',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100%'
//         }}>
//           <p>Unsupported file format</p>
//           <button 
//             onClick={onBack}
//             style={{
//               padding: '10px 20px',
//               marginTop: '20px',
//               fontSize: '16px',
//               backgroundColor: '#333',
//               color: 'white',
//               border: 'none',
//               borderRadius: '4px'
//             }}
//           >
//             Back
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PdfViewer;